import * as d3 from 'd3';
import { dN_Rect } from './d_rect';
import { drawHinge } from './drawHinge';
import { drawGrills } from './drawGrills';
import { drawTilt } from './drawTilt';
import { drawArrow } from './drawArrow';
import { getGlassDesign } from './glassPatternsDefs';

export function drawVent(nSections = 5, indexWindow = 1,
    svg, d = 2, initX = 20, initY = 20, frameWidth = 10, doorData = null, top = false, OneSection = false)
{
    const frameData = doorData?.frameData;
    const finish = doorData?.finish;
    const finishColor = doorData.flipped ? doorData?.finish?.exteriorColor?.value || 'white' :
                                           doorData?.finish?.interiorColor?.value || 'white' ;

    // Access type dynamically
    let type = 'type';
    let windowHeight = parseFloat(frameData.windowHeight_d); 
    if (top){
        type = 'typeTop';
        windowHeight = parseFloat(frameData?.uHeight_d || 0); 
    }
    const typeKey = `${type}${indexWindow}`;
    const widthKey = `windowWidth${indexWindow}_d`;
    const shapeKey = `shape${indexWindow}`;
    const shape = frameData?.[shapeKey] || 'Rectangle';

    if (frameData?.[typeKey] === 'End-Vent') {
        let windowWidth = parseFloat(frameData[widthKey]);
        //const windowHeight = parseFloat(frameData.windowHeight_d); // - 2*d;

        let adjustedWidth = (windowWidth - frameWidth * 2) / 2;

        let xOffset = initX ;
        for (let i = 1; i < indexWindow; i++) {
            const key = `windowWidth${i}_d`;
            xOffset += parseFloat(frameData[key] || 0) + 2 * frameWidth + 2*d ;
        }
        
      
        const glassType = `glassType${indexWindow}`;
        const glassColor = doorData?.glass?.[glassType].value || 'white';
        if (OneSection){
            xOffset = initX;
            windowWidth = parseFloat(frameData?.uWidth1_d)  - 
            2 * frameWidth - 2*d + parseInt(nSections);
            adjustedWidth = (windowWidth - 2 * frameWidth)*0.5;
        }
        const glassDesign = getGlassDesign(doorData);
        if (1) { //(shape === 'Rectangle') {
            dN_Rect(svg, d, xOffset , initY, [
                {
                    w: windowWidth,
                    h: windowHeight- 1,
                    color: glassColor || 'lightblue',
                    glassType: doorData?.glass?.glassType1.label,
                    glassDesign: glassDesign,
                    frameWidth: 0,
                    frameColor: finishColor,
                    lineFrameColor: 'black',
                    lineFrameThickness: 1,
                    outerStrokeColor: 'black',
                    outerStrokeWidth: 1
                }
            ], {
                labelText: `\u00A0✔`,
                subFrame: false,
                labelOptions: {
                    fontSize: 16,
                    fontColor: 'green',
                    fontOpacity: 0.2
                },
                drawFrame: true
            });

            dN_Rect(svg, d, xOffset , initY, [
                {
                    w: windowWidth, //2*adjustedWidth + 2*frameWidth - 1,
                    h: windowHeight/2 - 1,
                    color: glassColor, //'lightblue',
                    glassType: doorData?.glass?.glassType1.label,
                    glassDesign: glassDesign,
                    frameWidth,
                    frameColor: finishColor,
                    lineFrameColor: 'black',
                    lineFrameThickness: 1,
                    outerStrokeColor: 'black',
                    outerStrokeWidth: 1,
                    fullCorners: true
                }
            ], {
                labelText: `\u00A0${indexWindow} ✔`,
                subFrame: true,
                labelOptions: {
                    fontSize: 24,
                    fontColor: 'green',
                    fontOpacity: 0.2
                },
                drawFrame: true
            });
        }

        drawGrills(svg, indexWindow,
                    xOffset , initY,
                    windowWidth + d/2, /*2*adjustedWidth + 2*frameWidth,*/
                    (windowHeight-d)/2 ,
                    frameWidth,
                    doorData, top);

        drawGrills(svg, indexWindow,
                    xOffset , initY + windowHeight/2 + frameWidth ,
                    windowWidth + d/2, /*2*adjustedWidth + 2*frameWidth,*/
                    (windowHeight-d)/2 - frameWidth,
                    frameWidth,
                    doorData, top);

    }
}//drawFixedCasement
export function drawVent111(nSections = 5, indexWindow = 1,
    svg, d = 2, initX = 20, initY = 20, frameWidth = 10, doorData = null, top = false, OneSection = false)
  {
    const frameData = doorData?.frameData;
    const finish = doorData?.finish;
    const finishColor = doorData.flipped ? doorData?.finish?.exteriorColor?.value || 'white' :
                                           doorData?.finish?.interiorColor?.value || 'white' ;
  
    let type = 'type';
    let windowHeight = parseFloat(frameData.windowHeight_d); 
    if (top){
        type = 'typeTop';
        windowHeight = parseFloat(frameData?.uHeight_d || 0); 
    }
    const typeKey = `${type}${indexWindow}`;
    const widthKey = `windowWidth${indexWindow}_d`;
    const shapeKey = `shape${indexWindow}`;
    const shape = frameData?.[shapeKey] || 'rect';

    if (frameData?.[typeKey] === 'End-Vent') {
      let windowWidth = parseFloat(frameData[widthKey]);
      let adjustedHeight = (windowWidth - 2*d - frameWidth * 2) / 2;

      let yOffset = initY;
      for (let i = 1; i < indexWindow; i++) {
        const key = `windowWidth${i}_d`;
        yOffset += parseFloat(frameData[key] || 0) + 2 * frameWidth + 2*d;
      }

      const glassType = `glassType${indexWindow}`;
      const glassColor = doorData?.glass?.[glassType].value || 'white';
      const glassDesign = getGlassDesign(doorData);

      if (OneSection){
          yOffset = initY;
          windowWidth = parseFloat(frameData?.uWidth1_d)  -
          2 * frameWidth - 2*d + parseInt(nSections);
          adjustedHeight = (windowWidth - 2 * frameWidth)*0.5;
      }

      if (shape === 'rect') {
          dN_Rect(svg, d, initX, yOffset, [
            {
              w: windowHeight + 2*d,  // Swapped width/height
              h: windowWidth/2,
              color: glassColor || 'lightblue',
              glassType: doorData?.glass?.glassType1.label,
              glassDesign: glassDesign,
              frameWidth: 0,
              frameColor: finishColor,
              lineFrameColor: 'black',
              lineFrameThickness: 1,
              outerStrokeColor: 'black',
              outerStrokeWidth: 1
            },
            {
              h: windowWidth/2 -2*d,
              forceSubFrame: true,
              w: windowHeight + 2*d - 2*d - 1,
              color: glassColor || 'lightblue',
              glassType: doorData?.glass?.glassType1.label,
              glassDesign: glassDesign,
              frameWidth,
              frameColor: finishColor,
              lineFrameColor: 'black',
              lineFrameThickness: 1,
              outerStrokeColor: 'black',
              outerStrokeWidth: 1,
              fullCorners: true,
              displayLabel: false
            }
          ], {
            labelText: `\u00A0✔`,
            subFrame: false,
            labelOptions: {
              fontSize: 16,
              fontColor: 'green',
              fontOpacity: 0.2
            },
            drawFrame: true
          });
      }
  
      // Grills for both sections (vertical now)
      drawGrills(svg, indexWindow,
              initX, 
              yOffset, 
              windowHeight + 2*d, 
              windowWidth/2 -frameWidth/2, 
              frameWidth,
              doorData, top);
  
      drawGrills(svg, indexWindow,
                  initX, 
                  yOffset + adjustedHeight + 2* frameWidth -d , 
                  windowHeight + 2*d, 
                  windowWidth/2 -2*d - 1, 
                  frameWidth, 
                  doorData, top);
  
      // Optional: Draw tilt on lower section
      drawTilt(svg, initX, 
                    yOffset + windowWidth/2 + frameWidth/2, 
                    windowHeight + d, 
                    windowWidth/2 - 2*d - 1, 
                    frameWidth);
      /*  
      drawArrow(svg, initX, yOffset + d, 
                windowHeight + 2*d, windowWidth/2, frameWidth, 
                'green', 'toUp');
        */
    }
  }
  